import React,{ useState,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Row,
  Col,
  Card,
  Table,
  Badge,
  ProgressBar,
  Button,
  Alert
} from "react-bootstrap";
import { Link} from 'react-router-dom';
import '../../../../css/subscriptionplan.css'
import Modules from '../../../modules/modules';
import axiosInstance from '../../../../services/AxiosInstance';
import { sortSubscriptionPlansBySortOrder } from '../../../../utils/subscriptionPlansSort';

const Subscription= () =>{
    const navigate = useNavigate();
  const [promoCodeList, setPromoCodeList] = useState([]);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [promoCode, setPromoCode] = useState('');
  const [validPromo, setValidPromo] = useState(null);
  const [promoApplied, setPromoApplied] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [billingCycle, setBillingCycle] = useState('monthly');
  const [showModules, setShowModules] = useState(false);
  const [selectedModules, setSelectedModules] = useState([]);
  const[moduleList,setModulesList]=useState([])
  const [loading, setLoading] = useState(false);
  const [activeModuleTab, setActiveModuleTab] = useState('task'); // 'task', 'document'
 let  orgModulelist=[];
// const plans = [
//   {
//     name: "Basic",
//     originalPrice: 1990,
//     price: 1590,
//     discount: "20%",
//     storage: "24 GB",
//     users: 5,
//     isFree: true,
//   },
//   {
//     name: "Standard",
//     originalPrice: 4990,
//     price: 3493,
//     discount: "30%",
//     storage: "100 GB",
//     users: 50,
//   },
//   {
//     name: "Professional",
//     originalPrice: 9990,
//     price: 6993,
//     discount: "30%",
//     storage: "1,024 GB",
//     users: 100,
//     isPopular: true,
//   },
//   {
//     name: "Enterprise",
//     originalPrice: 19990,
//     price: 13993,
//     discount: "30%",
//     storage: "3 TB",
//     users: 250,
//   },
// ];
 useEffect(() => {
    const fetchModules = async () => {
      const token = localStorage.getItem('accessToken');
      const sanitizedToken = token.replace(/^"(.*)"$/, '$1');
      try {
        const response = await axiosInstance.get(`/modules/list`);
  
        // Handle different response structures
        const modulesData = response.data || response;
        // Ensure it's an array
        let modulesArray = [];
        if (Array.isArray(modulesData)) {
          modulesArray = modulesData;
        } else if (modulesData && Array.isArray(modulesData.data)) {
          modulesArray = modulesData.data;
        }
        
        setModulesList(modulesArray);
        orgModulelist = modulesArray;
      } catch (error) {
        console.error('Error fetching modules:', error);
        setModulesList([]);
        orgModulelist = [];
      }
    };
  
    fetchModules();
  }, []);
  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    const sanitizedToken = token.replace(/^"(.*)"$/, '$1');
    const fetchPromoCodes = async () => {
      try {
        const res = await axiosInstance.get(`/promocode/promocodelist`);
        const data =  res;
        setPromoCodeList(data.data);
      } catch (err) {
        console.error('Error fetching promo codes:', err);
      }
    };
  
    const fetchSubscriptionPlans = async () => {
        const token = localStorage.getItem('accessToken');
    const sanitizedToken = token.replace(/^"(.*)"$/, '$1');
      try {
        const res = await axiosInstance.get(`/plan/subscriptionlist`);
        const data = res;
        console.log("data",data,orgModulelist)
     const enrichedPlans = sortSubscriptionPlansBySortOrder(
       (data?.data || []).map(plan => {
  const moduleNames =plan?.Modules.map(moduleId => {
    const matched = orgModulelist.find(mod => mod.ModuleId === moduleId);
    return matched?.ModuleName || "Unknown";
  });
  return { ...plan, ModuleNames: moduleNames };
})
     );
console.log("enrichedplans",enrichedPlans)
  if(enrichedPlans!=''){
   setSubscriptionPlans(enrichedPlans)
  }    
      } catch (err) {
        console.error('Error fetching subscription plans:', err);
      }
    };
  
    fetchPromoCodes();
    fetchSubscriptionPlans();
  }, []);

  const handleApplyPromo = () => {
    const found = promoCodeList.find(p => p.PromoCodeName.toLowerCase() === promoCode.toLowerCase());
    if (found) {
      setValidPromo(found);
      setPromoApplied(true);
      alert('Promo code applied!');
    } else {
      setValidPromo(null);
      setPromoApplied(false);
      alert('Invalid promo code');
    }
  };

  const handleSelectPlan = (plan) => {
    setSelectedPlanId(plan.PlanId);
    setSelectedPlan(plan);
  
    const matchedModules = moduleList.filter((module) =>
      plan?.Modules?.includes(module.ModuleId)
    );
  
    setSelectedModules(matchedModules || []);
    setShowModules(true);
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
   setLoading(true)

    if (!selectedModules || selectedModules.length === 0) {
      alert('Please select a subscription plan that includes at least one module.');
      return;
    }
  
    const token = localStorage.getItem('accessToken');
    const userData = localStorage.getItem('user');
    const parsedUser = userData ? JSON.parse(userData) : null;
    const CorporateId = parsedUser?.id || '';
    const createdBy = parsedUser?.id || '';
  
    try {
      const response = await axiosInstance.put(`/auth/corporate/update`, JSON.stringify({
          selectedPlanId,
          CorporateId
        }),
    );
  
      const result = response;
  
      if (response) {
       //  toast.success('Payment submitted successfully!');
         setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } else {
        console.error('Submission failed:', result.message);
        alert('Error: ' + result.message);
      }
    } catch (error) {
      console.error('Network error:', error);
      alert('Something went wrong while submitting the form.');
    }
    setLoading(false);
  };


  const calculateDiscountedPrice = (plan) => {
    const price = billingCycle === 'monthly' ? plan.MonthlyPrice : plan.YearlyPrice;
    if (promoApplied && validPromo) {
      const discountAmount = (price * parseInt(validPromo.Discount)) / 100;
      return price - discountAmount;
    }
    return parseFloat(price);
  };

  // Group plans by module
  const getPlansByModule = (moduleType) => {
    return subscriptionPlans.filter(plan => {
      // First check if plan has Module object (from API response)
      if (plan.Module) {
        const moduleName = (plan.Module.name || plan.Module.display_name || '').toLowerCase();
        return moduleName === moduleType;
      }
      // Fallback: check module_id if Module object is not available
      if (plan.module_id) {
        if (moduleType === 'task') {
          return plan.module_id === 1;
        } else if (moduleType === 'document') {
          return plan.module_id === 2;
        }
      }
      // Legacy support: Check ModuleNames array if available
      if (plan.ModuleNames && plan.ModuleNames.length > 0) {
        return plan.ModuleNames.some(moduleName => {
          const name = (moduleName || '').toLowerCase();
          if (moduleType === 'task') {
            return name.includes('task');
          }
          if (moduleType === 'document') {
            return name.includes('document');
          }
          return false;
        });
      }
      // Legacy support: Check Modules array if available
      if (plan.Modules && plan.Modules.length > 0) {
        return plan.Modules.some(moduleId => {
          const module = moduleList.find(mod => mod.ModuleId === moduleId);
          if (module) {
            const moduleName = (module.ModuleName || '').toLowerCase();
            if (moduleType === 'task') {
              return moduleName.includes('task');
            }
            if (moduleType === 'document') {
              return moduleName.includes('document');
            }
          }
          return false;
        });
      }
      return false;
    });
  };

  const filteredPlans = getPlansByModule(activeModuleTab);

 
  

 return (
    <>
     <Card>
    <div className="subscription-container">
      <div className="card-header">
        <h4 className="card-title">Subscription Plans</h4>
      </div>



      {/* Module Tabs */}
      <div className="module-tabs-container mb-3">
        <div className="module-tabs d-flex">
          <button
            className={`module-tab ${activeModuleTab === 'task' ? 'active' : ''}`}
            onClick={() => setActiveModuleTab('task')}
          >
            <i className="fas fa-tasks me-2"></i>
            Tasks/Projects
          </button>
          <button
            className={`module-tab ${activeModuleTab === 'document' ? 'active' : ''}`}
            onClick={() => setActiveModuleTab('document')}
          >
            <i className="fas fa-file-alt me-2"></i>
            Documents
          </button>
        </div>
      </div>

      {/* Module Description */}
      <div className="mb-3">
        {(() => {
          // Get module description from backend
          const getModuleDescription = () => {
            // Ensure moduleList is an array before using .find()
            if (!Array.isArray(moduleList) || moduleList.length === 0) {
              // Fallback to static text if modules list is not available
              return activeModuleTab === 'task' 
                ? 'Streamline your workflow with our comprehensive task management solution. Organize, assign, and track tasks with ease. Features include task assignment, project management, email reminders, repetitive tasks, worksheet functionality, and document attachments. Perfect for teams looking to stay productive and ensure no task goes unnoticed or delayed.'
                : 'Securely store, organize, and manage all your business documents in one centralized location. Upload, categorize, and share documents with your team. Features include document storage with flexible storage limits, document classification, sharing capabilities, and secure access controls. Keep your important files organized and easily accessible whenever you need them.';
            }

            // Try to find module from modules list
            const module = moduleList.find(mod => {
              const moduleName = (mod.ModuleName || '').toLowerCase();
              return moduleName === activeModuleTab || moduleName.includes(activeModuleTab);
            });

            // If found, return its description
            if (module && module.Description) {
              return module.Description;
            }

            // Fallback: try to get from subscription plans Module object
            const planWithModule = subscriptionPlans.find(plan => {
              if (plan.Module) {
                const moduleName = (plan.Module.name || plan.Module.display_name || '').toLowerCase();
                return moduleName === activeModuleTab;
              }
              return false;
            });

            if (planWithModule && planWithModule.Module && planWithModule.Module.description) {
              return planWithModule.Module.description;
            }

            // Final fallback to static text
            return activeModuleTab === 'task' 
              ? 'Streamline your workflow with our comprehensive task management solution. Organize, assign, and track tasks with ease. Features include task assignment, project management, email reminders, repetitive tasks, worksheet functionality, and document attachments. Perfect for teams looking to stay productive and ensure no task goes unnoticed or delayed.'
              : 'Securely store, organize, and manage all your business documents in one centralized location. Upload, categorize, and share documents with your team. Features include document storage with flexible storage limits, document classification, sharing capabilities, and secure access controls. Keep your important files organized and easily accessible whenever you need them.';
          };

          return (
            <p style={{ fontSize: '1rem', textIndent: '2em', lineHeight: '1.6' }}>
              {getModuleDescription()}
            </p>
          );
        })()}
      </div>

      <div className="billing-toggle d-flex justify-content-center">
        <button
          className={billingCycle === "Monthly" ? "active" : ""}
          onClick={() => setBillingCycle("Monthly")}
        >
          Monthly
        </button>
        <button
          className={billingCycle === "Annually" ? "active" : ""}
          onClick={() => setBillingCycle("Annually")}
        >
          Annually <small>Save up to 30%</small>
        </button>
      </div>

<div className="row mt-3">
  <div className="col-12 d-flex justify-content-center">
    <div className="d-flex align-items-center gap-2">
      <input
        type="text"
        name="promocode"
        className="form-control"
        placeholder="Promo code"
        required
        value={promoCode}
        onChange={(e) => setPromoCode(e.target.value)}
        style={{ maxWidth: '200px' }}
      />
      <button
        className="btn btn-primary"
        onClick={handleApplyPromo}
      >
        Apply
      </button>
    </div>
  </div>
</div>
      <div className="plans-wrapper mt-3">
        {filteredPlans.length === 0 ? (
          <div className="text-center py-5">
            <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
            <p className="text-muted">No plans available for this module.</p>
          </div>
        ) : (
          filteredPlans.map((plan) => (
          <div key={plan.PlanName} className={`plan-card ${plan.isPopular ? "popular" : ""}`}>
            <h3>{plan.PlanName}</h3>
            <p className="price">
                {billingCycle=='Annually'?(
              <span className="original">${plan.MonthlyPrice}</span>
                ):(
                  <span className="original">${plan.YearlyPrice}</span>
                )}
              <span className="discount">-{plan.discount}</span>
              <br /> 
              <span>${billingCycle=='Annually'?plan.YearlyPrice:plan.MonthlyPrice}</span>
              {/* <span className="billing">/organization/month</span> */}
            </p>
            <p className="includes">Includes {plan.MaxUsers} users</p>
            <button className="buy-btn">Buy</button>
            <ul className="details">
              <li>👥 {plan.MaxUsers} users</li>
              <li>💾 {plan.MaxStorage} storage</li>
            </ul>
            {plan.isFree && <span className="free-label">Free</span>}
            <ul className="list-unstyled mt-3 mb-4">
                  {plan.ModuleNames.map((name, idx) => (
                    <li key={idx}>✅ {name}</li>
                  ))}
                </ul>
          </div>
        ))
        )}
      </div>
      
    
    </div>   
    
    </Card>
</>
  );
};
export default Subscription;